<template>
  <div class="getWayBillOperationLog">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="
              menuState == 1
                ? $t.getWayBillOperationLog.searchText1
                : $t.getWayBillOperationLog.searchText2
            "
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <template v-if="menuState == 1">
              <div class="list-item">
                {{ $t.getWayBillOperationLog.log }}：{{ item.OperationLog }}
              </div>
              <div class="list-item">
                {{ $t.getWayBillOperationLog.content }}：{{ item.LogContent }}
              </div>
              <div class="list-item">
                {{ $t.getWayBillOperationLog.username }}：{{ item.OperationUserName }}
              </div>
            </template>
            <template v-if="menuState == 2">
              <div class="list-item">
                {{ $t.getWayBillOperationLog.inquiryNumber }}：{{
                  item.PaymentInquiryNumber
                }}
              </div>
              <div class="list-item">
                {{ $t.getWayBillOperationLog.srNumber }}：{{
                  item.SerialRegistrationNumber
                }}
              </div>
              <div class="list-item">
                {{ $t.getWayBillOperationLog.content }}：{{ item.OperationReason }}
              </div>
              <div class="list-item">
                {{ $t.getWayBillOperationLog.date }}：{{ item.CreateTime }}
              </div>
              <div class="list-item">
                {{ $t.getWayBillOperationLog.username }}：{{ item.UserName }}
              </div>
            </template>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { List, Row, Col, Search, Tabs, Tab } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Search).use(Tabs).use(Tab);

export default {
  name: "getWayBillOperationLog",
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.getWayBillOperationLog.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.getWayBillOperationLog.tab2,
          name: 2,
          count: 0,
        },
      ],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
    };
  },
  watch: {
    menuState() {
      this.searchText = "";
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {},
  methods: {
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
    },
    getList(page) {
      if (!this.searchText) {
        this.loading = false;
        this.error = true;
        this.errorText = this.getErrorText();
        return;
      }
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        WB_Number: this.searchText,
      };
      this.$api.logisticsManagement
        .getWayBillOperationLog(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getErrorText() {
      if (this.menuState == 1) {
        return this.$t.meta.input + " " + this.$t.getWayBillOperationLog.searchText1;
      }
      if (this.menuState == 2) {
        return this.$t.meta.input + " " + this.$t.getWayBillOperationLog.searchText2;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.getWayBillOperationLog {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__action {
          width: 15%;
        }
        .van-search__content {
          padding: 0px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
